import { render, staticRenderFns } from "./VReopenDayForm.vue?vue&type=template&id=51ef1d6e&"
import script from "./VReopenDayForm.vue?vue&type=script&lang=js&"
export * from "./VReopenDayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports